import { render } from "./AssetViewer.vue?vue&type=template&id=95013e2c"
import script from "./AssetViewer.vue?vue&type=script&lang=js"
export * from "./AssetViewer.vue?vue&type=script&lang=js"

import "./AssetViewer.vue?vue&type=style&index=0&id=95013e2c&lang=scss"

import exportComponent from "/app/tmp/aft/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__